import * as createLabel from '../services/createLabel';

export default {
  namespace: 'createLabel',

  state: {
    TagAndRuleDetail: null,
    ruleLabelDirectoryList: null,
    tagBehaviorList: null,
    tagBehaviorConditionList: null,
  },

  effects: {
    // 创建非集合标签规则
    *insertOrUpdateTagAndRule({ payload: { values }, callback }, { call }) {
      const response = yield call(createLabel.insertOrUpdateTagAndRule, values);
      // response.code === 0 && callback && callback();
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    // 非集合标签规则详情
    *queryTagAndRule({ payload: { values }, callback }, { call, put }) {
      const response = yield call(createLabel.queryTagAndRule, values);
      yield put({
        type: 'save',
        payload: {
          TagAndRuleDetail: response?.data,
        },
      });
      response.code === 0 && callback && callback(response.data);
    },
    // 字段列表
    *queryFileList({ payload: { values }, callback }, { call, put }) {
      const response = yield call(createLabel.queryFileList, values);
      const responseTag = yield call(createLabel.getQueryTagOperatorValue, []);
      const treeList = response.data;
      yield put({
        type: 'save',
        payload: {
          ruleLabelDirectoryList: treeList,
          queryTagOperatorValue: responseTag.data,
        },
      });
      response.code === 0 && callback && callback(response.data);
    },
    // 行为列表
    *queryTagBehaviorList({ payload: { values }, callback }, { call, put }) {
      const response = yield call(createLabel.queryTagBehaviorList, values);
      const list = response?.data.map((item) => {
        return {
          nameZh: item.behaviorName,
          dictValue: item.id,
          ...item,
        };
      });
      yield put({
        type: 'save',
        payload: {
          tagBehaviorList: list,
        },
      });
      // response.code === 0 && callback && callback(response.data);
      response.code === 0 && callback && callback(list);
    },
    // 取值方式
    *queryTagBehaviorConditionList(
      { payload: { values }, callback },
      { call, put },
    ) {
      const response = yield call(
        createLabel.queryTagBehaviorConditionList,
        values,
      );
      yield put({
        type: 'save',
        payload: {
          tagBehaviorConditionList: response?.data || [],
        },
      });
      response.code === 0 && callback && callback(response.data);
    },
  },
  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },
  subscriptions: {},
};
